import { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './access-denied.module.css';

type AccessDeniedProps = {
  message?: string;
};

export const AccessDenied: FC<AccessDeniedProps> = memo(({ message }) => {
  const { t } = useTranslation('translation');
  const title = t('ui.accessDenied.title');
  const defaultMessage = t('ui.accessDenied.message');

  return (
    <div className={styles.container}>
      <div className={styles.alert}>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.message}>{message || defaultMessage}</p>
      </div>
    </div>
  );
});

export default AccessDenied;
